import {useTheme} from "@mui/styles"
import {examSessionStatuses} from "constants/constants"
import React, {useState, useEffect, useCallback, useMemo} from "react"
import {useSelector, useDispatch} from "react-redux"
import {useNavigate, useParams} from "react-router-dom"
import {
  Grid,
  Box,
  LinearProgress,
  Typography,
  CircularProgress,
  Backdrop, Button
} from "@mui/material"
import {clearActiveSession, logout} from "store/slices/user"

import {WorkSpace} from "./components"
import {BackdropLoad} from "components"
import {
  startExamSession,
  getSessionStatus,
  getTasksAnswers,
  getSessionDetails,
  submitCurentTusk,
  forcedFinishSession,
  cleanStateToDefault,
  clearState,
  addFlaggedTask,
  removeFlaggedTask,
  getSessionTasksStatus,
  getCurrentTaskData,
  getSessionData,
  sessionFailure
} from "store/slices/examsSession.js"
import {LINKS} from "constants/links.js"
import {
  ExamInstructions,
  ErrorMessage
} from "./components"
import {examsSessionWindow} from "./styles/styles"
import CustomPdfModal from "../../components/CustomPdfModal/CustomPdfModal"

import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen"
import OpenInFullIcon from "@mui/icons-material/OpenInFull"

import {
  TaskFooterSecondBar,
  TaskHeader,
  TaskFooterFirstBar,
  CustomDialogModal,
  PopUpTasks,
  PopUpFinish,
  PopUpFinishedExam,
  PopUpReminder,
  PopUpNotSubmit,
  PopUpResetCode
  // ExamInstructions
} from "@knowledge-pillars-education-inc/kp-fe-lib"

export function SphereEngineExam() {
  const styles = examsSessionWindow()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const theme = useTheme()

  const [openDoc, setOpenDoc] = useState(false)
  const [open, setOpen] = useState(false)
  const [popupType, setType] = useState(null)
  const [timer, setTimer] = useState(1000)
  const [codeEditorData, setCodeEditorData] = useState("")
  const [showLib, setShowLib] = useState(true)
  // const [instructionsOpen, setInstructionsOpen] = useState(false);

  const {
    loading,
    hasErrors,
    currentTask,
    sessionStatus,
    taskNumber,
    startLink,
    redirect,
    loadingMoveTo,
    engineCodeAnswer,
    sessionTasksStatus,
    currentSessionDetails,
    tasksAnswers,
    sessionFailureMessage
  } = useSelector((state) => state).examsSessionSlice

  const examusDisabledByCode = useSelector(
    (state) => state.groupSlice?.examusDisabledByCode
  )

  const {hasErrors: paymentErrors} = useSelector(
    (state) => state
  ).paymentSlice

  const {examName, userName, tasks, expirationDate} =
    currentSessionDetails || {}

  const isTaskFlagged = useMemo(() => {
    return sessionTasksStatus?.some(
      (e) => e.taskId === currentTask?.id && e.flag
    )
  }, [sessionTasksStatus, currentTask.id])

  const taskAnswer = useMemo(() => {
    return tasksAnswers?.find((task) => task.taskId === currentTask.id)
  }, [tasksAnswers, currentTask.id])

  const ModalTitle = useMemo(() => {
    switch (popupType) {
      case "finishExamFirst":
      case "finishExamEnd":
        return "Finish exam"
      case "finished-exem":
        return "Exam finished"
      case "ExamReminder":
        return "Reminder"
      case "tasks":
        return "Review All Tasks"
      case "notSubmittedTask":
        return "Action required"
      case "refreshCode":
        return "Reset task"
      default:
        return null
    }
  }, [popupType])

  const checkAllPassedQuestions = useMemo(() => {
    return (
      sessionTasksStatus &&
      !sessionTasksStatus?.find((task) => !task.flag && !task.answered)
    )
  }, [sessionTasksStatus])

  const fetchData = async (sessionId) => {
    try {
      await dispatch(getSessionData(sessionId))
      await dispatch(getCurrentTaskData())
      await dispatch(getTasksAnswers())
      await dispatch(getSessionTasksStatus())
    } catch(err) {
      dispatch(sessionFailure(err))
    }
  }

  useEffect(() => {
    let interval
    if (currentSessionDetails._id && sessionStatus && ![examSessionStatuses.Initiating, examSessionStatuses.Initiated, examSessionStatuses.InProgress].includes(sessionStatus)) {
      navigate("/")

      return
    }

    if (currentSessionDetails._id && sessionStatus === examSessionStatuses.Initiating) {
      interval = setInterval(async () => {
        dispatch(getSessionStatus(currentSessionDetails._id))
      }, 3000)
    }
    if (currentSessionDetails._id && sessionStatus === examSessionStatuses.Initiated) {
      clearInterval(interval)
      dispatch(getSessionDetails(params.sessionId))
    }
    return () => clearInterval(interval)
  }, [sessionStatus, currentSessionDetails._id]); // eslint-disable-line

  useEffect(() => {
    if (params.sessionId) {
      fetchData(params.sessionId)
    }
  }, [params.sessionId]); // eslint-disable-line

  useEffect(() => {
    if (currentSessionDetails._id) {
      dispatch(getSessionStatus(currentSessionDetails._id))
    }
  }, [currentSessionDetails._id]); // eslint-disable-line

  useEffect(() => {
    if (startLink && redirect && !examusDisabledByCode && !params.sessionId) {
      window.location.replace(startLink)
    }
  }, [startLink, redirect, examusDisabledByCode, params])

  useEffect(() => {
    if (hasErrors === "Code is not submitted yet") {
      setType("notSubmittedTask")
      setOpen(true)
    }
  }, [hasErrors])

  useEffect(() => {
    if (timer < 300001 && timer > 299000) {
      setType("ExamReminder")
    }
    if (timer < 100 && popupType !== "scored") {
      setOpen(true)
      setType("finished-exem")
    }
  }, [timer]); // eslint-disable-line

  useEffect(() => {
    if (currentTask?.type === "practical") {
      if (taskAnswer?.sourceCode) {
        setCodeEditorData(taskAnswer?.sourceCode)
      } else {
        setCodeEditorData(currentTask?.practicalDetails?.template)
      }
    }
  }, [taskAnswer, currentTask])

  const handleStartSession = useCallback(() => {
    // const examusEnabled = !examusDisabledByCode;
    const devExamUrl = `${LINKS.examWindow}/${params.examCode}/${currentSessionDetails._id}`
    // if (currentSessionDetails._id && examusEnabled) {
    //   dispatch(startExamSession(currentSessionDetails._id));
    // }
    if (currentSessionDetails._id) {
      dispatch(startExamSession(currentSessionDetails._id)).then(() => {
        navigate(devExamUrl)
        fetchData(params.sessionId)
      })
    }
  }, [currentSessionDetails._id, LINKS, params, examusDisabledByCode]); // eslint-disable-line

  const handlePDFClick = () => {
    setOpenDoc((prevState) => !prevState)
  }

  const handleClose = async (closeType) => {
    if (closeType === "confirm") {
      dispatch(forcedFinishSession()).finally(() => {
        // localStorage.removeItem("taskId");
        window.setTimeout(() => {
          dispatch(clearActiveSession())
          dispatch(clearState())
          dispatch(logout())
          navigate("/", {replace: true})
        }, 3000)
      })
      setType("scored")
      setOpen(true)
    }
    if (closeType === "continue") {
      setOpen(false)
      setType(false)
      return
    }
    if (closeType === "review-tasks") {
      setType("tasks")
      return
    }
    if (closeType === "exit") {
      dispatch(clearActiveSession())
      navigate("/")
      dispatch(cleanStateToDefault())
      return
    }
    if (closeType === "close") {
      setType("")
      return
    }
    if (closeType === "nextTask") {
      skipTask()
      setType("")
      return
    }
    if (closeType === "repeatQuestion") {
      setType("")
      return
    }
  }

  const handleFlagClickFooter = () => async () => {
    if (isTaskFlagged) {
      await dispatch(removeFlaggedTask(params.sessionId, currentTask.id))
    } else {
      await dispatch(addFlaggedTask(params.sessionId, currentTask.id))
    }
    await dispatch(getSessionTasksStatus())
  }

  const skipTask = () => {
    if (taskNumber < tasks?.length) {
      let taskId = tasks[taskNumber].taskId
      dispatch(getCurrentTaskData(taskId))
    }
  }

  const onPrevClick = () => {
    if (taskNumber > 1) {
      let taskId = tasks[taskNumber - 2].taskId
      dispatch(getCurrentTaskData(taskId))
    }
  }

  const goThisTask = async (taskId) => {
    await dispatch(getCurrentTaskData(taskId))
    setType(null)
  }

  const submitTask = () => {
    if (!engineCodeAnswer && currentTask?.type === "practical") {
      setType("notSubmittedTask")
      setOpen(true)
      return
    }
    dispatch(submitCurentTusk()).then((res) => {
      if (res) {
        if (taskNumber === tasks?.length) {
          setType("tasks")
        } else {
          skipTask()
        }
      }
    })
  }

  const refreshCode = () => {
    setCodeEditorData(currentTask?.practicalDetails?.template)
  }

  const renderHelper = () => {
    switch (popupType) {
      case "tasks":
        return (
          <PopUpTasks handleClick={goThisTask} tasks={sessionTasksStatus} />
        )
      case "finishExamFirst":
      case "finishExamEnd":
        return <PopUpFinish handleClose={handleClose} popupType={popupType} />
      case "finished-exem":
        return <PopUpFinishedExam handleClose={handleClose} />
      case "ExamReminder":
        return <PopUpReminder handleClose={handleClose} />
      case "notSubmittedTask":
        return <PopUpNotSubmit handleClose={handleClose} />
      case "refreshCode":
        return (
          <PopUpResetCode handleClose={handleClose} refreshCode={refreshCode} />
        )
      case "scored":
        return (
          <Backdrop className={styles.backdrop} open={true}>
            <Typography
              className={styles.loadingMessage}
              variant="h6"
              align="center"
            >
              Thank you for taking the exam. We will contact you in the next
              24-48h with your results. <br />
              <b>
                We are saving your exam information. <br /> Please do not close
                or leave this tab and we will redirect you to the main page in
                about 1 minute.
              </b>
            </Typography>
            <CircularProgress className={styles.progressBar} color="inherit" />
          </Backdrop>
        )
      default:
        return null
    }
  }

  if (!params.sessionId && !currentSessionDetails._id) {
    return <BackdropLoad open={true} />
  }

  if (sessionStatus === examSessionStatuses.Initiating) {
    return (
      <Backdrop className={styles.backdrop} open={true}>
        <Typography variant="h6" align="center">
          We are currently preparing your exam and it may take few minutes.{" "}
          <br />
          <b>Please don't refresh or close the tab.</b>
        </Typography>
        <CircularProgress className={styles.progressBar} color="inherit" />
      </Backdrop>
    )
  }

  if (sessionFailureMessage) {
    return <ErrorMessage message={sessionFailureMessage} />
  }

  // #region I don't know why, but this part breaks exam session restore on page reload
  // if (!params.sessionId && !examusDisabledByCode) {
  //   return <BackdropLoad open={true} />;
  // }

  // if (!sessionStatus || loadingMoveTo) {
  //   if (!examusDisabledByCode) {
  //     return <BackdropLoad open={loading} />;
  //   }
  // }
  // #endregion

  if (
    ((hasErrors &&
      !/Code is not submitted yet/.test(hasErrors) &&
      !/Session is not in progress/.test(hasErrors))) ||
    paymentErrors
  ) {
    if (!examusDisabledByCode) return <ErrorMessage />
  }

  return (
    <>
      <Grid container>
       {sessionStatus === examSessionStatuses.Initiated ? (
         <Grid item xs={12}>
           <ExamInstructions
             headerOff
             fullScreen
             handleClick={handleStartSession}
           />
         </Grid>
       ) : (
        <>
          <Box
            sx={{
              position: "fixed",
              top: "0",
              zIndex: 2,
              overflow: "hidden",
              width: "100%",
              height: "auto",
              maxHeight: showLib ? "100px" : 0,
              transition: "all .35s ease-out",
              "& > div": {
                position: "relative"
              }
            }}
          >
            <TaskHeader
              studentName={userName}
              sessionId={params?.sessionId}
              examName={examName}
              deadline={expirationDate}
              setTimer={setTimer}
              checkAllPassedQuestions={checkAllPassedQuestions}
              loading={loading}
              setType={setType}
              logo="/icons/kp_logo.png"
            />
          </Box>
          <Grid
            item
            xs={12}
            className={styles.sphereEngineWorkSpace}
            style={{
              height: !showLib ? "100vh" : undefined,
              marginTop: !showLib ? 0 : undefined,
              marginBottom: !showLib ? 0 : undefined,
              transition: "all 0.35s ease-out"
            }}
          >
            {openDoc && (
              <div className={styles.pdfWrapper}>
                <CustomPdfModal open={openDoc} setOpen={setOpenDoc} />
              </div>
            )}
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                overflowY: "auto"
              }}
            >
              <WorkSpace
                popupType={popupType}
                open={open}
                taskAnswer={taskAnswer}
                codeEditorData={codeEditorData}
                onRefresh={refreshCode}
              />
            </Box>
            <Box
              position="absolute"
              right={20}
              bottom={15}
              zIndex={10}
              sx={{
                transition: ".2s",
                opacity: .5,
                "&:hover": {
                  opacity: 1,
                  transition: ".2s"
                }
              }}
            >
              <Button
                onClick={() => setShowLib(!showLib)}
                sx={{
                  transition: ".2s",
                  boxShadow: 1,
                  minWidth: "auto",
                  "&:hover": {
                    background: theme.palette.white.main,
                    transition: ".2s"
                  }
                }}
              >
                {showLib ? (
                  <OpenInFullIcon fontSize="small"/>
                ) : (
                  <CloseFullscreenIcon fontSize="small"/>
                )}
              </Button>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            className={styles.sphereEngineFooter}
            sx={{
              maxHeight: !showLib ? 0 : "200px",
              overflow: "hidden",
              transition: "all 0.35s ease-out"
            }}
          >
            <Box className={styles.loadingBarContainer}>
              {loadingMoveTo || loading ? <LinearProgress /> : null}
            </Box>
            <TaskFooterFirstBar
              handleFlagClick={handleFlagClickFooter}
              currentTaskNumber={taskNumber}
              tasksAmount={tasks?.length}
              btnFlaggedDisable={loading}
              setOpenDoc={handlePDFClick}
              openDoc={openDoc}
              isTaskFlagged={isTaskFlagged}
              questionType={currentTask?.type}
              examCode={currentTask?.examCode}
            />
            <TaskFooterSecondBar
              nextDisabled={loading}
              prevDisabled={taskNumber === 1}
              onNextClick={submitTask}
              onPrevClick={onPrevClick}
              onNextQuestion={skipTask}
              isTaskFlagged={isTaskFlagged}
              skipTaskShow={taskNumber !== tasks?.length}
            />
          </Grid>
        </>
      )}
      </Grid>
      {popupType && (
        <CustomDialogModal
          popupType={popupType}
          examName={examName}
          setType={setType}
          ModalTitle={ModalTitle}
        >
          {renderHelper()}
        </CustomDialogModal>
      )}
    </>
  )
}
